import { PageEnum } from '@/enums/pageEnum';

export const isLoginPageEnabled = process.env.VUE_APP_LOGIN_ENABLED === '1';

export function getLoginPagePath() {
  return PageEnum.BASE_LOGIN;
}

export function navigateToLogin(router, method = 'push') {
  if (!isLoginPageEnabled) {
    return false;
  }

  router[method](getLoginPagePath());
  return true;
}
